var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-xs rounded-lg p-1 mx-1",class:{
    'bg-sky-100': _vm.canChange,
    'bg-gray-100': !_vm.canChange,
  }},[_vm._v(" "+_vm._s(_vm.displayText)+" "),(_vm.canChange && _vm.canDelete)?_c('XButton',{staticClass:"p-1 w-4 h-4 bg-red-200 rounded-lg",on:{"click":_vm.deleteOption}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }